import { render, staticRenderFns } from "./AccountTap.vue?vue&type=template&id=e64e4bf0&"
import script from "./AccountTap.vue?vue&type=script&lang=js&"
export * from "./AccountTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports